import axios from 'axios';

const contactUsApi = async (values, langIsoCode) => {
  const url = '/General/contact';
  try {
    const res = await axios.post(url, values, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
        lang: langIsoCode
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default contactUsApi;
